
<template>
  <div class=" my-3 ">
    <div class="attribute-item-row d-flex">
      <div
        v-if="(procedures||[]).length"
        class="m-auto mx-2"
      >
        <v-icon @click="isExpanded=!isExpanded">
          {{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
        </v-icon>
      </div>
      <div
        v-for="attribute in displayItems"
        :key="attribute.key"
        class="attribute-item pa-1"
      >
        <div class="attribute-item-title">
          {{ attribute.displayName }}
        </div>
        <div class="attribute-item-value">
          {{ attribute.formatter? attribute.formatter(requestInfo[attribute.key]):requestInfo[attribute.key] }}
        </div>
      </div>
      <request-stepper
        :current-step="requestInfo.requestStep"
        class="align-items-center"
      ></request-stepper>
    </div>
    <div v-if="isExpanded">
      <v-row
        v-for="(procedure, index) in procedures"
        :key="index"
      >
        <v-col class="mx-5">
          <div class="attribute-item-title">
            {{ local.bankruptcy.bankruptcyFile.procedureCode }}
          </div>
          <div class="attribute-item-value">
            {{ procedure.procedureCode }}
          </div>
        </v-col>
        <v-col>
          <div class="attribute-item-title">
            {{ local.bankruptcy.bankruptcyFile.openedProcedureName }}
          </div>
          <div class="attribute-item-value">
            {{ procedure.procedureName }}
          </div>
        </v-col>
        <v-col>
          <div class="attribute-item-title">
            {{ local.bankruptcy.bankruptcyFile.procedureStatus }}
          </div>
          <div class="attribute-item-value">
            {{ procedure.statusName }}
          </div>
        </v-col>
        <v-col>
          <div class="attribute-item-title">
            {{ local.bankruptcy.bankruptcyFile.openedProcedureDate }}
          </div>
          <div class="attribute-item-value">
            {{ toHijriDate(procedure.procedureDate) }}
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { toHijriDate } from '@/helpers/utils';
import RequestStepper from './request-stepper.vue';
import { mainRequestStep, procedureStatusEnum } from '../../helpers/enum';

export default {
  name: 'RequestSummary',
  components: { RequestStepper },
  props: {
    requestInfo: {
      type: Object,
      required: true,
    },
    procedures: {
      type: Array,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      toHijriDate,
      isExpanded: false,
    };
  },
  computed: {
    headers() {
      return [
        {
          key: 'requestCategoryName',
          displayName: this.local.bankruptcy.bankruptcyFile.requestCategoryName,
        },
        {
          key: 'legalCapacityName',
          displayName: this.local.bankruptcy.bankruptcyFile.legalCapacityName,
        },
        {
          key: 'requestOwnerTypeName',
          displayName: this.local.bankruptcy.bankruptcyFile.onBehalfOf,
        },
        {
          key: 'courtName',
          displayName: this.local.bankruptcy.bankruptcyFile.courtName,
        },
        {
          key: 'openedProcedureName',
          displayName: this.local.bankruptcy.bankruptcyFile.openedProcedureName,
        },
        {
          key: 'openedProcedureDate',
          displayName: this.local.bankruptcy.bankruptcyFile.openedProcedureDate,
          formatter: toHijriDate,
        },

      ];
    },
    displayItems() {
      return this.headers.map((prop) => {
        prop.value = this.requestInfo[prop.key];
        return prop;
      }).filter(item => item.value);
    },
  },
  watch: {},
  mounted() { 
    this.updateRequestInfoCurrentStep();
  },
  methods: {
    updateRequestInfoCurrentStep() {
      if (this.procedures.find(p => p.statusId == procedureStatusEnum.Closed))
        this.requestInfo.requestStep = mainRequestStep.done;
    },
  },

};
</script>

<style lang="scss" scoped>
.attribute-item-row {
  display: flex;
  justify-content: space-between;
  position: relative;
  border: 1px solid #dbdbdb;
  background: var(--app-light-secondary-color);
}

.attribute-item {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 0 10px 0 10px;
}

    .attribute-item-title {
        font-size: 14px;
        font-weight: bold;
        color: var(--app-primary-color);
    }

.attribute-item-value {
  font-weight: bolder;
  font-size: 16px;
  color: black
}
</style>
